import { WSForm, WSInputDate } from "@wingspanhq/fe-component-library";
import { IAttributeDefinition } from "@wingspanhq/payments/dist/interfaces";

type Props = {
  definition: IAttributeDefinition;
  disabled?: boolean;
};

export const FieldDatetime: React.FC<Props> = props => {
  return (
    <WSForm.Field
      name={props.definition.key}
      component={WSInputDate}
      componentProps={{
        label: props.definition.name,
        helperText: props.definition.description,
        required: props.definition.required,
        showTime: true,
        disabled: props.disabled
      }}
    />
  );
};
